export enum PartMediaActionType {
  DOCUMENTATION = 'documentation',
  GALLERY = 'gallery',
}

export enum PartMediaImageType {
  CALCULATED = 'calculated',
  UPLOADED = 'uploaded',
}
